import { User } from 'store/user/types';
import qs from 'qs';

export const getMicroFrontendParams = (
  user: User,
  apiUrl: string,
  authToken: string,
  buildingUuid: string,
  cartId: string,
  locationId: string,
  locale?: string,
  forPayment?: boolean,
  isMobileDevice?: boolean,
  error?: string,
  paymentId?: string,
) => {
  const miniAppProps = {
    cartId,
    locationId,
    buildingUuid,
    authToken: `${authToken}`,
    firstName: user.first_name,
    lastName: user.last_name,
    userId: user.id,
    userUuid: user.uuid,
    apiUrl,
    locale,
    forPayment,
    isMobileDevice,
    error,
    paymentId,
  };

  return qs.stringify(miniAppProps);
};
